import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWrench = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 22,
	fill: "none",
	viewBox: "0 0 21 22",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.8 9A6.6 6.6 0 0 1 18 1.5l-3.8 3.8L15.6 7l3.8-4a6.6 6.6 0 0 1-7.3 10.2L4.2 21 0 16.8l7.8-7.9zm10.9-2.1a4.6 4.6 0 0 1-7 3.9l-7.5 7.4-1.4-1.4 7.4-7.5a4.6 4.6 0 0 1 4.2-7L12.7 4a2 2 0 0 0 0 2.9l1.5 1.4a2 2 0 0 0 2.8 0l1.7-1.7v.3z",
		clipRule: "evenodd"
	})
});
export default SvgWrench;
